import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_97: DocMigration = {
  maxSchemaVersion: "0.0.97",
  description: "remove settings overrides",
  apply(json: any) {
    function updateHeadCasing(headCasing: any) {
      headCasing.headCasingType = "ARCHED_SLICES";
      const slices = [
        {
          height: headCasing.headCasingHeight,
          depthOffset: headCasing.headCasingDepth,
        },
      ];
      headCasing.headCasingArchedSlices = slices;
      headCasing.headCasingInteriorDepth = 0;

      delete headCasing.headCasingHeight;
      delete headCasing.headCasingDepth;
      delete headCasing.headCasingExtension;
    }

    if (json.roomLayouts) {
      for (const layoutKey of Object.keys(json.roomLayouts)) {
        const layout = json.roomLayouts[layoutKey];
        if (layout.openingPatterns) {
          for (const openingPattern of layout.openingPatterns) {
            if (openingPattern.openings) {
              for (const opening of openingPattern.openings) {
                if (opening.exteriorCasing) {
                  if (opening.exteriorCasing.headCasingType === "ARCHED_TRIM") {
                    updateHeadCasing(opening.exteriorCasing);
                  }
                }
              }
            }
          }
        }
      }
    }
    if (json.settings) {
      for (const settingsKey of Object.keys(json.settings)) {
        const settingsObj = json.settings[settingsKey];
        if (settingsObj.type && settingsObj.type === "EXTERIOR_DOOR_CASING_SETTINGS") {
          if (settingsObj.headCasingType === "ARCHED_TRIM") {
            updateHeadCasing(settingsObj);
          }
        }
        if (settingsObj.type && settingsObj.type === "EXTERIOR_WINDOW_CASING_SETTINGS") {
          if (settingsObj.headCasingType === "ARCHED_TRIM") {
            updateHeadCasing(settingsObj);
          }
        }
        if (settingsObj.type && settingsObj.type === "DOOR_CATALOG_SETTINGS") {
          if (settingsObj.doorTypes) {
            for (const doorKey of Object.keys(settingsObj.doorTypes)) {
              const door = settingsObj.doorTypes[doorKey];
              if (door.exteriorCasing) {
                if (door.exteriorCasing.headCasingType === "ARCHED_TRIM") {
                  updateHeadCasing(door.exteriorCasing);
                }
              }
            }
          }
        }
        if (settingsObj.type && settingsObj.type === "WINDOW_CATALOG_SETTINGS") {
          if (settingsObj.windowTypes) {
            for (const windowKey of Object.keys(settingsObj.windowTypes)) {
              const window = settingsObj.windowTypes[windowKey];
              if (window.exteriorCasing) {
                if (window.exteriorCasing.headCasingType === "ARCHED_TRIM") {
                  updateHeadCasing(window.exteriorCasing);
                }
              }
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_97;
